import React from 'react';
import CountUp from "react-countup";
import { Card, CardBody, Col } from 'reactstrap';

const Widgets = ({ projectTotals, settledPrices, filter}) => {
    const data = projectTotals.filter(item => {
        if (filter === 'All') {
            return true;
        }
        return item.block_name === filter;
    });
    const breakEven = data.reduce((sum, item) => sum + item['initial_price'], 0);
    const expectedEarnings = data.reduce((sum, item) => sum + item['expected_price'], 0);

    const numPayments = settledPrices.reduce((acc, item) => {
        if (filter === 'All' || filter === item.block_name) {
            acc += item.num_payments_expected
        }
        return acc
    }, 0);



    const ecomWidgets = [
        {
            id: 1,
            cardColor: "secondary",
            label: "Break Even",
            counter: breakEven,
            bgcolor: "info",
            icon: "ri-price-tag-3-line",
            decimals: 2,
            prefix: "€",
            separator: ",",
            suffix: "",
            type: "Initial", // Added type for this widget
        },
        {
            id: 2,
            cardColor: "primary",
            label: "Expected earnings",
            counter: expectedEarnings,
            bgcolor: "success",
            icon: "ri-money-dollar-circle-line",
            decimals: 2,
            prefix: "€",
            suffix: "",
            type: "Settled", // Added type for this widget
        },
        {
            id: 3,
            cardColor: "secondary",
            label: "Number of Payments expected",
            counter: numPayments,
            bgcolor: "info",
            icon: "ri-bank-card-line",
            decimals: 0,
            prefix: " ",
            separator: ",",
            suffix: "",
            type: "Paid", // Added type for this widget
        },
    ];

    return (
        <React.Fragment>
            {ecomWidgets.map((item, key) => (
                <Col xl={4} md={6} key={key}>
                    <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0">{item.label}</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                        <CountUp
                                            start={0}
                                            prefix={item.prefix}
                                            suffix={item.suffix}
                                            separator={item.separator}
                                            end={item.counter}
                                            decimals={item.decimals}
                                            duration={1}
                                        />
                                    </h4>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                    <span className={`avatar-title rounded fs-3 bg-${item.bgcolor}-subtle`}>
                                        <i className={`text-${item.bgcolor} ${item.icon}`}></i>
                                    </span>
                                </div>
                            </div>
                            {/* Pass type dynamically */}
                            {/*<div className="mt-4">*/}
                            {/*    <StoreVisits*/}
                            {/*        phases={phases}*/}
                            {/*        project_total={project_total}*/}
                            {/*        project_paid={project_paid}*/}
                            {/*        project_initial={project_initial}*/}
                            {/*        type={item.type} // Pass type dynamically*/}
                            {/*    />*/}
                            {/*</div>*/}
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </React.Fragment>
    );
};

export default Widgets;
